import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => (
  <div>
    <SimpleTable>
      <div>
        <div>Trigger ID:</div>
        <div>{node.extras.triggerId}</div>
      </div>
      <div>
        <div>Trigger Name:</div>
        <div>{node.extras.triggerName || 'Untitled'}</div>
      </div>
    </SimpleTable>
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactSubscribed/ContactSubscribedDisplay.jsx